// @flow

import type { List }           from 'immutable';
import { createSelector }      from 'reselect';
import type { LocationRecord } from '../modules/react-router/domain/react-router.domain';

const selectRouterHistory = (state) => state.get('routerHistory');

export const selectPageHistory = createSelector(
  selectRouterHistory,
  (routerHistory) => routerHistory.get('pathHistory'),
);

export const selectCurrentLocation = createSelector(
  selectPageHistory,
  (pageHistory: List<LocationRecord>) => pageHistory.last(),
);

export const selectPreviousLocation = createSelector(
  selectPageHistory,
  (pageHistory: List<LocationRecord>) => pageHistory.pop().last(),
);


// WEBPACK FOOTER //
// ./src/selectors/routerHistory.js